export default __webpack_public_path__ + "static/media/dollar.57a7401d.svg";